module.exports = function($){
  $.FW   = true;
  $.path = $.g;
  return $;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/~/babel-core/~/core-js/modules/$.fw.js
 ** module id = 165
 ** module chunks = 0
 **/